import repository from '@/services/repository';

const resource = '/quotations';

export default {
    /*get(projectId: string) {
        if (projectId) {
            return repository.get(`${resource}?projectId=${projectId}`);
        } else {
            return repository.get(`${resource}`);
        }
    },*/
    getList(projectId: string) {
        return repository.get<IQuotationBasicListItemDto[]>(`${resource}/List?projectId=${projectId}`);
    },
    lookup(options: any, projectId: string, contactId: string) {
        const formData = new FormData();

        for ( const key in options ) {
            if (options.hasOwnProperty(key)) {
                formData.append(key, JSON.stringify(options[key]));
            }
        }

        if (!projectId) {
            projectId = '';
        }
        if (!contactId) {
            contactId = '';
        }

        return repository.post(`${resource}/lookup?projectId=${projectId}&contactId=${contactId}`, formData, {
            headers: {'Content-Type': 'multipart/form-data' },
        });
    },
    getSingle(id: string) {
        return repository.get(`${resource}/${id}`);
    },
    getStats() {
        return repository.get<IQuotationStatsDto>(`${resource}/stats`);
    },
    duplicate(id: string) {
        return repository.post(`${resource}/${id}/duplicate`);
    },
    generate(payload: any) {
        return repository.post(`${resource}/generate`, payload);
    },
    create(projectId: any) {
        return repository.post(`${resource}?projectId=${projectId}`);
    },
    update(payload: any) {
        return repository.put(`${resource}/${payload.id}`, payload);
    },
    delete(payload: any) {
        return repository.delete(`${resource}/${payload.id}`);
    },
    mail(payload: any) {
        return repository.post(`${resource}/Mail`, payload);
    },
};
